const generateHomeLink = () => '/'
const generateLandingLink = () => '/landing'
const generatePoolsLink = () => '/pools'
const generateStakingLink = () => '/staking'
const generateStakingVaultsLink = () => generateStakingLink() + '/vaults'
const generateStakingTokensLink = () => generateStakingLink() + '/tokens'
const generateStakingV1Link = () => '/staking-v1'
const generateRewardsLink = () => '/rewards'
const generateUnstakingLink = () => '/unstaking'
const generatePoolDetailsLink = () => '/fundraise'
const generateMaintenanceLink = () => '/maintenance'
const generateLabsLink = () => '/labs'
const generateLaunchLink = () => '/launch-legacy'
const generateDropsLink = () => '/drops'
const generateVaultLink = () => '/vault'
const generateMaintenanceAdminsLink = () =>
  generateMaintenanceLink() + '/admins'
const generateMaintenancePoolsLink = () => generateMaintenanceLink() + '/pools'
const generatePoolDetailsAddressLink = () =>
  generatePoolDetailsLink() + '/:slug'
const generateLabsPoolsAllLink = () =>
  generateLabsLink() + generatePoolsLink() + '/all'
const generateLaunchPoolsAllLink = () =>
  generateLaunchLink() + generatePoolsLink() + '/all'
const generateDropDetailsAddressLink = () => generateDropsLink() + '/:slug'
const generateDropDetailsAddressLinkWithChapter = () =>
  generateDropsLink() + '/:slug/chapter/:chapter'
const generateDropDetailsLeaderboardLink = () =>
  generateDropDetailsAddressLink() + '/leaderboard'
const generateDropDetailsMissionsLink = () =>
  generateDropDetailsAddressLink() + '/missions'
const generateDropDetailsAboutLink = () =>
  generateDropDetailsAddressLink() + '/about'
const generateDropsAllLink = () => generateDropsLink() + '/all'
const generateMemecoinsLink = () => '/launch'
const generateMemecoinsDetailsLink = () => generateMemecoinsLink() + '/:address'
const generateMemecoinsLauncherLink = () =>
  generateMemecoinsLink() + '/launcher'

const routes = {
  landing: generateLandingLink(),
  home: generateHomeLink(),
  staking: {
    vaults: generateStakingVaultsLink(),
    tokens: generateStakingTokensLink(),
  },
  stakingV1: generateStakingV1Link(),
  rewards: generateRewardsLink(),
  account: '/account',
  dashboard: {
    index: '/dashboard',
    launch: '/dashboard/launch',
    labs: '/dashboard/labs',
    drops: '/dashboard/drops',
    vault: '/dashboard/vault',
  },
  myzap: {
    index: '/myzap',
    menu: '/myzap/menu',
    profile: '/myzap/profile',
    socials: '/myzap/socials',
    communications: '/myzap/communications',
    tokensAndVaults: '/myzap/tokens-and-vaults',
    claimingHistory: '/myzap/claiming-history',
    ownedCoins: '/myzap/owned-coins',
    createdCoins: '/myzap/created-coins',
    tokensClaim: '/myzap/tokens-claim',
    tokensStaked: '/myzap/tokens-and-vaults',
    vaultsStaked: '/myzap/vaults-staked',
    vaultsClaimed: '/myzap/vaults-claimed',
    investors: '/myzap/investors',
    tokensHeld: '/myzap/portfolio',
    tokenDetails: '/myzap/portfolio/:address',
  },
  roadmap: '/roadmap',
  unstaking: generateUnstakingLink(),
  poolDetails: {
    index: generatePoolDetailsLink(),
    slug: generatePoolDetailsAddressLink(),
  },
  pools: {
    index: generatePoolsLink(),
  },
  maintenance: {
    index: generateMaintenanceLink(),
    admins: generateMaintenanceAdminsLink(),
    pools: generateMaintenancePoolsLink(),
  },
  labs: {
    index: generateLabsLink(),
    pools: generateLabsPoolsAllLink(),
  },
  launch: {
    index: generateLaunchLink(),
    pools: generateLaunchPoolsAllLink(),
  },
  season: {
    index: '/season',
    details: '/season/:slug',
    previous: '/season/previous',
    previousDetails: '/season/previous/:seasonId',
  },
  drops: {
    index: generateDropsLink(),
    slug: generateDropDetailsAddressLink(),
    missions: generateDropDetailsMissionsLink(),
    chapter: generateDropDetailsAddressLinkWithChapter(),
    leaderboard: generateDropDetailsLeaderboardLink(),
    about: generateDropDetailsAboutLink(),
    all: generateDropsAllLink(),
  },
  memecoins: {
    index: generateMemecoinsLink(),
    details: generateMemecoinsDetailsLink(),
    launcher: generateMemecoinsLauncherLink(),
  },
  vault: {
    index: generateVaultLink(),
  },
  invite: '/zap-invite/:code',
  solLink: '/bsc-sol-link',
}

export const links = {
  drops: {
    slug: (slug: string) => routes.drops.index + `/${slug}`,
  },
  invite: (code: string) => `/zap-invite/${code}`,
  memecoins: {
    address: (address: string) => routes.memecoins.index + `/${address}`,
  },
}

export default routes
